export default __webpack_public_path__ + "static/avatar-5292607f4921b0a0bc66632f1bc84fc9.jpeg";